import { IObservation } from '@ahryman40k/ts-fhir-types/lib/R4';
import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { IModifyFiller } from '../../models/manual-data-recording.models';

@Component({
  selector: 'inc-manual-recorded-data-table',
  templateUrl: './manual-recorded-data-table.component.html',
  styleUrls: ['./manual-recorded-data-table.component.scss'],
})
export class ManualRecordedDataTableComponent implements OnInit {
  @Input() observations: IObservation[] = [];
  @Input() modifyFiller: IModifyFiller = { state: false, data: undefined };
  @Input() dateFormat: string = 'yyyy.MM.dd hh:mm';

  @Input() observationPatientTemplate?: TemplateRef<any>;
  @Input() observationTypeTemplate?: TemplateRef<any>;
  @Input() observationValueTemplate?: TemplateRef<any>;

  @Output() onModify: EventEmitter<IObservation> = new EventEmitter<IObservation>();
  @Output() onDelete: EventEmitter<string> = new EventEmitter<string>();

  displayedColumns: string[] = ['patient', 'obsType', 'obsValue', 'obsTime', 'modify', 'delete'];

  constructor() { }

  ngOnInit() { }

  modify(observation: IObservation): void {
    this.onModify.emit(observation);
  }

  delete(id: string): void {
    this.onDelete.emit(id);
  }
}
